// Bootstrap our application
import "./_Bootstrap/Bootstrap";
import { StrictMode } from "react";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
// Import the Redux store and browser history
import { history, store } from "./_Bootstrap/RoutingAndStore";
import CustomerDisplayWrapper from "./Common/CustomerDisplay/CustomerDisplayWrapper";
import { NavigationBlock } from "./Common/Dialogs/NavigationBlock";
import { ErrorBoundary } from "./Common/Misc/ErrorBoundary";
import ScrollToTop from "./Common/Misc/ScrollToTop";
import { UIContainer } from "./Common/Misc/UIContainer";
import Expired from "./Routes/Expired/Expired";
import Shopfront from "./Shopfront"; // Need this to load before bootstrapping for moment to work (for some reason)

// Create the root container
const RootContainer = (
    <StrictMode>
        <ErrorBoundary>
            <Provider store={store}>
                <HistoryRouter history={history}>
                    <UIContainer>
                        <NavigationBlock>
                            <ScrollToTop>
                                <Routes>
                                    <Route
                                        path="/expired"
                                        element={<Expired />}
                                    />
                                    <Route
                                        path="/sell/display"
                                        key="customer-display"
                                        element={<CustomerDisplayWrapper />}
                                    />
                                    <Route
                                        path="*"
                                        element={<Shopfront />}
                                    />
                                </Routes>
                            </ScrollToTop>
                        </NavigationBlock>
                    </UIContainer>
                </HistoryRouter>
            </Provider>
        </ErrorBoundary>
    </StrictMode>
);

export default RootContainer;
